import { apiInterceptor } from 'utils/apiInterceptor';
export async function ResetChannelStreamKey(projectId, channelId) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/channels/${channelId}/resetStreamKey?projectId=${projectId}`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}
